// <blog-post-slider> — horizontal, scroll-snap card slider with prev/next arrows.
// Self-contained web component: no globals, cleans up its own listeners.
if (!customElements.get('blog-post-slider')) {
  customElements.define(
    'blog-post-slider',
    class BlogPostSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bps-track]');
        this.arrowsWrap = this.querySelector('[data-bps-arrows]');
        this.prevButton = this.querySelector('[data-bps-direction="prev"]');
        this.nextButton = this.querySelector('[data-bps-direction="next"]');

        if (!this.track) return;

        // Bind once so we can remove the exact same references later.
        this.onPrev = () => this.scrollByCards(-1);
        this.onNext = () => this.scrollByCards(1);
        this.onScroll = () => this.updateState();
        this.onResize = () => this.updateState();

        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.updateState();
      }

      disconnectedCallback() {
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      // Distance of one card (card width + the gap between cards).
      get step() {
        const card = this.track.querySelector('.blog-post-slider__card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      scrollByCards(direction) {
        this.track.scrollBy({ left: this.step * direction, behavior: 'smooth' });
      }

      // Toggle arrow availability and hide the controls entirely when there is
      // nothing to scroll (fewer cards than fit in view).
      updateState() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;
        const isScrollable = maxScroll > 1;

        if (this.arrowsWrap) {
          this.arrowsWrap.hidden = !isScrollable;
        }
        if (this.prevButton) {
          this.prevButton.disabled = scrollLeft <= 1;
        }
        if (this.nextButton) {
          this.nextButton.disabled = scrollLeft >= maxScroll - 1;
        }
      }
    }
  );
}
